module.exports = __webpack_public_path__ + "img/IMG_2293.a6bc8519.jpg";